export interface ActivityDateType {
  id: string;
  name: string;
}

export const ACTIVITY_DATE_TYPES: ActivityDateType[] = [
  {
    id: "single",
    name: "Eén datum",
  },
  {
    id: "period",
    name: "Periode",
  },
];
